import React from 'react';
import { SURFACE } from './layout';
import { isInAppLink } from './client/toolSelection';
import { resolveElsewhere } from './elsewhereModel';

// Each tool chip takes the next colour in this cycle so the flow reads as
// distinct stops, not one repeated pill.
const CHIP = [
  'border-[#32B1FF]/30 bg-[#32B1FF]/10 text-[#32B1FF] hover:bg-[#32B1FF]/20',
  'border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 dark:border-emerald-800/60 dark:bg-emerald-900/20 dark:text-emerald-300',
  'border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100 dark:border-amber-800/60 dark:bg-amber-900/20 dark:text-amber-300',
  'border-violet-300 bg-violet-50 text-violet-700 hover:bg-violet-100 dark:border-violet-800/60 dark:bg-violet-900/20 dark:text-violet-300',
];

// `elsewhere` is LINKS, never copied numbers (spec §3). The chips come from
// resolveElsewhere: the app's own tools open the app's own page, and any other destination
// is shown only when it is a valid web address. `onOpen(link)` runs when a link that
// leads inside the app is opened (click or middle-click), so the caller can select this client
// for the tool first; links to other sites never call it.
const ElsewhereLinks = ({ elsewhere, onOpen }) => {
  const links = resolveElsewhere(elsewhere);
  if (links.length === 0) return null;
  return (
    <section className={SURFACE} aria-label="Elsewhere">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Elsewhere</h3>
      <p className="mt-0.5 mb-3 pb-3 border-b border-gray-100 dark:border-gray-800 text-xs text-gray-500 dark:text-gray-400">Open this client in the connected tools — links only, never copied numbers.</p>
      {/* A left-to-right flow: coloured tool chips joined by arrows, so the row
          reads as a path through the connected tools, not a flat link list. */}
      <div className="flex flex-wrap items-center gap-2">
        {links.map((l, i) => (
          <React.Fragment key={i}>
            {i > 0 && (
              <svg
                className="h-5 w-9 shrink-0 text-gray-400 dark:text-gray-500"
                viewBox="0 0 40 24" fill="none" stroke="currentColor"
                strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
              >
                <line x1="2" y1="12" x2="34" y2="12" />
                <polyline points="28 7 34 12 28 17" />
              </svg>
            )}
            <a
              href={l.url}
              onClick={() => { if (onOpen && isInAppLink(l.url)) onOpen(l); }}
              onAuxClick={() => { if (onOpen && isInAppLink(l.url)) onOpen(l); }}
              target="_blank"
              rel="noreferrer"
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition-colors ${CHIP[i % CHIP.length]}`}
            >
              {l.label}
              <svg
                className="h-3.5 w-3.5 opacity-70"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
              >
                <path d="M7 17L17 7" />
                <path d="M7 7h10v10" />
              </svg>
            </a>
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default ElsewhereLinks;
